import React from "react";
import { Box, Button, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import BrushRoundedIcon from "@mui/icons-material/BrushRounded";
import DevicesRoundedIcon from "@mui/icons-material/DevicesRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";

const serviceCards = [
  {
    icon: <BrushRoundedIcon />,
    title: "Website design",
    text: "Clean websites for service businesses, care providers, booking pages, and local organizations.",
  },
  {
    icon: <DevicesRoundedIcon />,
    title: "Responsive builds",
    text: "Pages designed to work well on desktop, tablet, and mobile without feeling crowded.",
  },
  {
    icon: <SupportAgentRoundedIcon />,
    title: "Ongoing support",
    text: "Help with updates, landing pages, forms, product pages, and practical improvements after launch.",
  },
];

export default function WebDesignPage() {
  return (
    <Box sx={{ bgcolor: "#f7f8fb", minHeight: "100vh", py: { xs: 5, md: 8 } }}>
      <Container maxWidth="lg">
        <Stack spacing={4}>
          <Box sx={{ maxWidth: 780 }}>
            <Typography sx={{ color: "#52627a", fontWeight: 700, mb: 1 }}>
              Micro Logic Web Design
            </Typography>
            <Typography
              component="h1"
              sx={{
                color: "#182230",
                fontSize: { xs: 34, md: 52 },
                fontWeight: 850,
                lineHeight: 1.06,
                mb: 2,
              }}
            >
              Practical websites for businesses that need to be found and trusted.
            </Typography>
            <Typography sx={{ color: "#52627a", fontSize: { xs: 16, md: 18 }, lineHeight: 1.7, mb: 3 }}>
              We design and build clear, mobile-friendly websites, landing pages, and product pages that help customers understand what you offer and take the next step.
            </Typography>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
              <Button
                variant="contained"
                href="https://digitalcare4u.com/"
                endIcon={<ArrowForwardRoundedIcon />}
                sx={{ textTransform: "none", borderRadius: 2, px: 2.5, py: 1.2, fontWeight: 800 }}
              >
                Visit Digital Care 4U
              </Button>
              <Button
                variant="outlined"
                href="/about"
                sx={{ textTransform: "none", borderRadius: 2, px: 2.5, py: 1.2, fontWeight: 800 }}
              >
                Learn about us
              </Button>
            </Stack>
          </Box>

          <Grid container spacing={2.5}>
            {serviceCards.map((card) => (
              <Grid item xs={12} md={4} key={card.title}>
                <Paper
                  elevation={0}
                  sx={{
                    height: "100%",
                    p: 3,
                    border: "1px solid #dde3ea",
                    borderRadius: 2,
                    bgcolor: "#fff",
                  }}
                >
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      display: "grid",
                      placeItems: "center",
                      borderRadius: 2,
                      bgcolor: "#eef4ff",
                      color: "#2454d6",
                      mb: 2,
                    }}
                  >
                    {card.icon}
                  </Box>
                  <Typography sx={{ fontSize: 20, fontWeight: 850, color: "#182230", mb: 1 }}>
                    {card.title}
                  </Typography>
                  <Typography sx={{ color: "#52627a", lineHeight: 1.7 }}>
                    {card.text}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </Container>
    </Box>
  );
}
